<xemex-table
  [data]="tableData()"
  [columns]="columns"
  [loading]="loading()"
  [totalCount]="totalCount()"
  [pageSize]="pageSize"
  (pageChange)="onPageChange($event)"
>
  <xemex-table-filter-bar
    [filterGroups]="filterGroups"
    [searchPlaceholder]="'devices.detailTabs.activity.filter.initiator' | translate"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"
  >
    <div actions class="flex items-center gap-2">
      <xemex-activity-date-range (rangeChange)="onDateRangeChange($event)" />
    </div>
  </xemex-table-filter-bar>

  <ng-template #actionsCell let-row>
    @if (row.activity.message) {
      <button
        mat-icon-button
        data-testid="activity-message"
        [matTooltip]="'general.viewMessage' | translate"
        (click)="openMessage(row.activity); $event.stopPropagation()"
      >
        <mat-icon>article</mat-icon>
      </button>
    }
  </ng-template>

  <ng-template #emptyState>
    @if (failed()) {
      <span class="text-text-error" role="alert">{{
        'installations.activity.loadFailed' | translate
      }}</span>
    } @else if (filtered()) {
      {{ 'general.noData' | translate }}
    } @else {
      <xemex-installation-activity-empty [devices]="devices()" />
    }
  </ng-template>
</xemex-table>
